(() => {
  window.DigitalizModules = window.DigitalizModules || {};
  if (window.DigitalizModules.productGalleryInteractions) return;
  window.DigitalizModules.productGalleryInteractions = true;

  const api = window.DigitalizProductGalleryInteractions || {};

  function fancyboxOptions() {
    return {
      animated: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
      Toolbar: {
        display: {
          left: ['counter'],
          middle: [],
          right: ['zoomIn', 'zoomOut', 'toggle1to1', 'fullscreen', 'close']
        }
      }
    };
  }

  // The full gallery opens in Fancybox; every slide image/video is a bound
  // [data-fancybox] anchor, so clicking the image opens the lightbox at that slide.
  function bindFancybox(root) {
    const sectionId = root.dataset.sectionId;
    if (!sectionId) return;
    if (root.dataset.fancyboxBound === 'true') return;
    if (!window.Fancybox || typeof window.Fancybox.bind !== 'function') return;

    root.dataset.fancyboxBound = 'true';
    // Exclude Splide's loop clones so the lightbox group has each image once.
    window.Fancybox.bind(
      root,
      `[data-product-gallery-slide]:not(.is-clone) [data-fancybox="product-gallery-${sectionId}"]`,
      fancyboxOptions()
    );
  }

  // The bottom-right zoom icon has no handler of its own: it's pointer-events:none
  // (see component-product-gallery.css), so a click on it falls through to the
  // image anchor underneath and opens Fancybox at that slide — identical to
  // clicking the image anywhere else, which always resolves the right slide.
  function bind(root) {
    bindFancybox(root);
  }

  function sync() {}

  api.bind = bind;
  api.sync = sync;

  window.DigitalizProductGalleryInteractions = api;
})();
